/* RAYIN Minimal — theme scripts (no dependencies) */
(function () {
  'use strict';

  /* ---------------- Sticky header ---------------- */
  function initStickyHeader() {
    var header = document.querySelector('[data-sticky-header]');
    if (!header) return;
    var threshold = parseInt(header.getAttribute('data-scroll-threshold'), 10) || 24;
    var ticking = false;

    function update() {
      if (window.scrollY > threshold) {
        header.classList.add('is-stuck');
      } else {
        header.classList.remove('is-stuck');
      }
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
    update();
  }

  /* ---------------- Mobile menu ---------------- */
  function initMobileMenu() {
    var toggles = document.querySelectorAll('[data-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (!menu || !toggles.length) return;

    function setOpen(open) {
      menu.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
      toggles.forEach(function (t) { t.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    }
    toggles.forEach(function (t) {
      t.addEventListener('click', function () {
        setOpen(!menu.classList.contains('is-open'));
      });
    });
    menu.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') setOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });
  }

  /* ---------------- Accordions (FAQ + product) ---------------- */
  function initAccordions() {
    document.querySelectorAll('[data-accordion]').forEach(function (root) {
      var single = root.getAttribute('data-accordion-single') === 'true';
      var buttons = root.querySelectorAll('[data-accordion-trigger]');

      function close(btn) {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        btn.setAttribute('aria-expanded', 'false');
        if (panel) panel.style.maxHeight = '0px';
      }
      function open(btn) {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        btn.setAttribute('aria-expanded', 'true');
        if (panel) panel.style.maxHeight = panel.scrollHeight + 'px';
      }

      buttons.forEach(function (btn) {
        if (btn.getAttribute('aria-expanded') === 'true') {
          open(btn);
        } else {
          close(btn);
        }
        btn.addEventListener('click', function () {
          var isOpen = btn.getAttribute('aria-expanded') === 'true';
          if (single) {
            buttons.forEach(function (other) { if (other !== btn) close(other); });
          }
          if (isOpen) { close(btn); } else { open(btn); }
        });
      });

      window.addEventListener('resize', function () {
        buttons.forEach(function (btn) {
          if (btn.getAttribute('aria-expanded') === 'true') open(btn);
        });
      });
    });
  }

  /* ---------------- Product gallery ---------------- */
  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-gallery-main]');
      var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      if (!main || !thumbs.length) return;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-src');
          var srcset = thumb.getAttribute('data-srcset');
          var alt = thumb.getAttribute('data-alt') || '';
          if (src) main.setAttribute('src', src);
          if (srcset) main.setAttribute('srcset', srcset);
          main.setAttribute('alt', alt);
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });
  }

  /* ---------------- Variant picker ---------------- */
  function initVariantPickers() {
    document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
      var form = picker.closest('form');
      var dataEl = document.getElementById(picker.getAttribute('data-variants-id'));
      if (!form || !dataEl) return;

      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var idInputs = document.querySelectorAll('[data-variant-id-input]');
      var priceEl = document.querySelector('[data-product-price]');
      var submitBtn = form.querySelector('[data-add-to-cart]');
      var moneyFormat = picker.getAttribute('data-money-format') || '${{amount}}';

      function formatMoney(cents) {
        var value = (cents / 100).toFixed(2);
        var parts = value.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, parts.join('.'));
      }

      function selectedOptions() {
        return Array.prototype.map.call(
          picker.querySelectorAll('[data-option-index]'),
          function (group) {
            var checked = group.querySelector('input:checked');
            return checked ? checked.value : null;
          }
        );
      }

      function update() {
        var opts = selectedOptions();
        var match = variants.find(function (v) {
          return opts.every(function (opt, i) { return opt === null || v.options[i] === opt; });
        });

        picker.querySelectorAll('[data-selected-value]').forEach(function (el, i) {
          if (opts[i]) el.textContent = opts[i];
        });

        if (!match) {
          if (submitBtn) {
            submitBtn.setAttribute('disabled', 'disabled');
            submitBtn.textContent = submitBtn.getAttribute('data-unavailable-text') || 'Unavailable';
          }
          return;
        }

        idInputs.forEach(function (input) { input.value = match.id; });

        if (priceEl) {
          var html = '<span class="price__now">' + formatMoney(match.price) + '</span>';
          if (match.compare_at_price && match.compare_at_price > match.price) {
            html += '<span class="price__was">' + formatMoney(match.compare_at_price) + '</span>';
            var save = Math.round(((match.compare_at_price - match.price) / match.compare_at_price) * 100);
            html += '<span class="price__badge">Save ' + save + '%</span>';
          }
          priceEl.innerHTML = html;
        }

        if (submitBtn) {
          if (match.available) {
            submitBtn.removeAttribute('disabled');
            submitBtn.textContent = submitBtn.getAttribute('data-default-text') || 'Add to cart';
          } else {
            submitBtn.setAttribute('disabled', 'disabled');
            submitBtn.textContent = submitBtn.getAttribute('data-soldout-text') || 'Sold out';
          }
        }

        if (window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      picker.addEventListener('change', update);
      update();
    });
  }

  /* ---------------- Quantity steppers ---------------- */
  function initQuantity() {
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      if (!input) return;
      wrap.querySelectorAll('[data-qty-change]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-qty-change'), 10);
          var min = parseInt(input.getAttribute('min'), 10);
          if (isNaN(min)) min = 1;
          var next = (parseInt(input.value, 10) || min) + step;
          if (next < min) next = min;
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------------- Cart line auto-update ---------------- */
  function initCartForm() {
    var form = document.querySelector('[data-cart-form]');
    if (!form) return;
    form.querySelectorAll('[data-cart-qty] input').forEach(function (input) {
      input.addEventListener('change', function () { form.submit(); });
    });
  }

  /* ---------------- Reveal on scroll ---------------- */
  function initReveal() {
    var items = document.querySelectorAll('.reveal');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------------- Copy link (share) ---------------- */
  function initShare() {
    document.querySelectorAll('[data-copy-link]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-copy-link') || window.location.href;
        if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () {
            var original = btn.textContent;
            btn.textContent = btn.getAttribute('data-copied-text') || 'Copied';
            setTimeout(function () { btn.textContent = original; }, 1800);
          });
        }
      });
    });
  }

  function init() {
    initStickyHeader();
    initMobileMenu();
    initAccordions();
    initGallery();
    initVariantPickers();
    initQuantity();
    initCartForm();
    initReveal();
    initShare();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
